import { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const LANGUAGE_KEY = 'app_language'

export function useLanguageSwitch() {
  const location = useLocation()
  const navigate = useNavigate()
  const [currentLanguage, setCurrentLanguage] = useState<string>('en')

  // Initialize language from URL first, then localStorage
  useEffect(() => {
    // Get language from URL path
    const urlLanguage = location.pathname.split('/')[1]
    if (urlLanguage && ['en', 'es'].includes(urlLanguage)) {
      setCurrentLanguage(urlLanguage)
      // Sync with localStorage
      localStorage.setItem(LANGUAGE_KEY, urlLanguage)
    } else {
      // Fallback to localStorage
      const savedLanguage = localStorage.getItem(LANGUAGE_KEY)
      if (savedLanguage && ['en', 'es'].includes(savedLanguage)) {
        setCurrentLanguage(savedLanguage)
      }
    }
  }, [location.pathname])

  const switchLanguage = useCallback((newLocale: string) => {
    // Save to localStorage
    localStorage.setItem(LANGUAGE_KEY, newLocale)
    setCurrentLanguage(newLocale)
    
    // Navigate to the new locale path
    const pathWithoutLocale = location.pathname.replace(/^\/[a-z]{2}/, '')
    const newPath = `/${newLocale}${pathWithoutLocale}`
    navigate(newPath)
  }, [location.pathname, navigate])

  return { 
    switchLanguage, 
    currentLanguage,
    setCurrentLanguage 
  }
}
